
import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'light' | 'dark';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', variant = 'light', className }) => {
  const sizeClasses = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-10'
  };

  return (
    <img 
      src="/images/logo.png"
      alt="BioGene"
      className={`w-auto ${sizeClasses[size]} ${className || ''}`}
    />
  );
};

export default Logo;
